// extracted by mini-css-extract-plugin
export default {"root":"DomainList-root_aBWlb","container":"DomainList-container_SqN2z","list":"DomainList-list_YLcAu"};